<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "subAll"
    }
</script>

<style scoped>

</style>
